import { ModalContent } from '@fiverr-private/overlay';

export default ModalContent;
